import { ThemeColors } from '../../../'

export interface VersionBannerColors {
  Background: ThemeColors
  CloseIconColor: ThemeColors
  FontColor: ThemeColors
}

export const versionBannerColors: VersionBannerColors = {
  Background: {
    default: 'bg.panel',
  },
  CloseIconColor: {
    default: 'fg.subtle',
  },
  FontColor: {
    default: 'fg.subtle',
  },
}
